export default __webpack_public_path__ + "static/media/NFT-DEX.7d365743.jpg";